module.exports = __webpack_public_path__ + "img/join-now.e5424886.png";